var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 12.354a.82.82 0 0 1 .996-.589A4.09 4.09 0 0 1 19 15.726v1.637a.818.818 0 1 1-1.636 0v-1.636a2.456 2.456 0 0 0-1.84-2.377.82.82 0 0 1-.588-.996M12.107 2.569a.82.82 0 0 1 1.065-.451 4.091 4.091 0 0 1 0 7.585.818.818 0 1 1-.614-1.517 2.455 2.455 0 0 0 0-4.552.82.82 0 0 1-.451-1.065M6.058 11.636h3.797c.892 0 1.501 0 2.023.14a4.09 4.09 0 0 1 2.893 2.892c.188.703.133 1.454.139 2.174 0 .088.002.265-.042.43a1.23 1.23 0 0 1-.868.867 1.6 1.6 0 0 1-.428.042 703 703 0 0 0-11.23 0c-.088 0-.265.002-.43-.042a1.23 1.23 0 0 1-.867-.868c-.044-.164-.043-.341-.042-.429.006-.718-.048-1.472.14-2.174a4.09 4.09 0 0 1 2.892-2.892c.522-.14 1.13-.14 2.023-.14",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.866 5.91a4.09 4.09 0 1 1 8.18 0 4.09 4.09 0 0 1-8.18 0",
    clipRule: "evenodd"
  })));
};
export default SvgUsers;